/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController,AlertController,LoadingController, IonRouterOutlet, Platform } from '@ionic/angular';
import { UtilService } from '@shared/utils/util';
import { UserService } from '@shared/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from '@shared/services/location.service';
import { Preferences } from '@capacitor/preferences';
import { Md5 } from 'ts-md5';
import { Observable, Subscription } from 'rxjs';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
  providers:[UtilService,IonRouterOutlet]
})
export class ResetPasswordPage implements OnInit {


  public myForm = new FormGroup({
    userpassControl: new FormControl('',  Validators.compose([Validators.maxLength(15), Validators.required])),
    reenterpassControl: new FormControl('',  Validators.compose([Validators.maxLength(15), Validators.required]))
  });
  submitAttempt: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private userData : any;
  show: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public backButton: Subscription|any;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    public platform: Platform,
    private util: UtilService,
    public userSerice: UserService,
    private translate: TranslateService,
    public locationSvc: LocationService,
  ) {

    this.util.initTranslate();

    Preferences.get({key:'USER_DATA'}).then((val) =>{
      console.log('Got some data from Storage: ' + JSON.stringify(val));
      this.userData = val.value ? JSON.parse(val.value) : null;
    })
  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.goBack();
      });
    }
  }
  
  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  }

  ngOnInit() {
  }

  goBack(){
    this.modalCtrl.dismiss();
  }

  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }

  async showLoading(message:string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      // translucent: true,

      // backdropDismiss: true
    });

    loading.present();
  }

  async resetPass(){
    this.submitAttempt = true;
    if(!this.myForm.valid){
      this.showModalAlert(this.translate.instant('fixHighlighted'));
      return;
    }
    if(this.myForm.controls['userpassControl'].value != this.myForm.controls['reenterpassControl'].value){
      this.showModalAlert(this.translate.instant('passwordsDontMatch'));
      return;
    } 
    const loader = this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
    });
    (await loader).present();


    const encryptedPass = Md5.hashStr(String(this.myForm.controls['userpassControl'].value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let theObs : Observable<any>;
    
    this.userData.password = encryptedPass;
    this.userData.needsEmailValidation = false;
    this.userData.needsPasswordReset = false;

    Preferences.get({key:'LAST_LOCATION'}).then(async (val) => {
      val = val.value ? JSON.parse(val.value) : null;
      let location = val;
      const teleportationLocation = this.locationSvc.getTeleportationLocation();
      if(teleportationLocation != null){
        location = teleportationLocation;
      };

      // Retrieve and add FCM token to userData before sending to server
      const fcmToken = await Preferences.get({ key: 'TOKEN' });
      if (fcmToken && fcmToken.value) {
        this.userData.token = fcmToken.value;
      } else {
        const localToken = localStorage.getItem('TOKEN');
        if (localToken) {
          this.userData.token = localToken;
        }
      }

      theObs =  this.userSerice.upsertSoul(this.userData, location, false, false, false);

      theObs.subscribe(async data =>{
        console.log('upsert subscribe entered');
        console.log(JSON.stringify(data));

        if(data != '{not ok}'){
          this.userData = JSON.parse(data);
          Preferences.set({key:'USER_DATA', value: JSON.stringify(this.userData)}).then((_val) => {
            console.log('userdata saved to DB');
          });

    
          (await loader).dismiss();
          
          this.showModalAlert(this.translate.instant('passwordResetSuccessfully'));

          this.modalCtrl.dismiss('loggedIn');

        }else {
          (await loader).dismiss();
        }
      },
      async err =>{
        console.log('Error: ' + JSON.stringify(err));
        (await loader).dismiss();
      })

    })
  }

  password() {
    this.show = !this.show;
  }

}
